import SinglePost from './SinglePost';

export default SinglePost;
